/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpsertAnthropicInferenceConfigRequestBody = {
  /**
   * Enable inspection. Requires a saved signing secret.
   */
  enabled?: boolean | undefined;
  /**
   * New Anthropic signing secret. Omit to preserve the saved secret.
   */
  signingSecret?: string | undefined;
};

/** @internal */
export type UpsertAnthropicInferenceConfigRequestBody$Outbound = {
  enabled?: boolean | undefined;
  signing_secret?: string | undefined;
};

/** @internal */
export const UpsertAnthropicInferenceConfigRequestBody$outboundSchema:
  z.ZodMiniType<
    UpsertAnthropicInferenceConfigRequestBody$Outbound,
    UpsertAnthropicInferenceConfigRequestBody
  > = z.pipe(
    z.object({
      enabled: z.optional(z.boolean()),
      signingSecret: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        signingSecret: "signing_secret",
      });
    }),
  );

export function upsertAnthropicInferenceConfigRequestBodyToJSON(
  upsertAnthropicInferenceConfigRequestBody:
    UpsertAnthropicInferenceConfigRequestBody,
): string {
  return JSON.stringify(
    UpsertAnthropicInferenceConfigRequestBody$outboundSchema.parse(
      upsertAnthropicInferenceConfigRequestBody,
    ),
  );
}
